import React from 'react';

// Pixel art icon component using CSS
const PixelIcon: React.FC = () => {
  return (
    <div className="inline-block relative" aria-hidden="true">
      <div className="grid grid-cols-8 gap-[1px] w-6 h-6">
        {/* Row 1 */}
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        
        {/* Row 2 */}
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        
        {/* Row 3 */}
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-white"></div>
        <div className="w-[2px] h-[2px] bg-blue-300"></div>
        <div className="w-[2px] h-[2px] bg-blue-300"></div>
        <div className="w-[2px] h-[2px] bg-white"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        
        {/* Row 4 */}
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-300"></div>
        <div className="w-[2px] h-[2px] bg-yellow-400"></div>
        <div className="w-[2px] h-[2px] bg-yellow-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-300"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        
        {/* Row 5 */}
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-300"></div>
        <div className="w-[2px] h-[2px] bg-blue-300"></div>
        <div className="w-[2px] h-[2px] bg-blue-300"></div>
        <div className="w-[2px] h-[2px] bg-blue-300"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        
        {/* Row 6 */}
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-400"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        
        {/* Row 7 */}
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-blue-500"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        
        {/* Row 8 */}
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
        <div className="w-[2px] h-[2px] bg-transparent"></div>
      </div>
    </div>
  );
};

export const Footer: React.FC = () => {
  return (
    <footer className="bg-white border-t border-gray-200 py-4 mt-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
          <PixelIcon />
          <span>Dreamt up and created by</span>
          <span className="font-semibold text-blue-600 hover:text-blue-700 transition-colors cursor-default">
            Blockehh
          </span>
        </div>
      </div>
    </footer>
  );
};






